module.exports = __webpack_public_path__ + "img/smell-3.30d6cf4a.svg";